// import {ReactMount as Components} from './Libraries/bootstrap';
import './Libraries/bootstrap';
import Alpine from 'alpinejs';

// import './Libraries/Accordion/listener';
// import './Libraries/Aos/listener';
// import './Libraries/Article/listener';
// import './Libraries/BlockContent/listener';
// import './Libraries/Highlighter/listener';
// import './Libraries/Lightbox/listener';
// import './Libraries/MegaMenu/listener';
// import './Libraries/ReadMore/listener';
// import './Libraries/ScrollTo/listener';
// import './Libraries/ShowMore';
// import './Libraries/StickyNav';
// import './Libraries/Swiper/listener';
// import './Libraries/TippyPopUp';
// import './Libraries/VideoEmbed';
// import './Libraries/VideoModal/listener';
// import './Libraries/VideoStream/listener';

// Components({
//     Example: () => import('./Libraries/example'),
// });
// import carousel from './components/carousels/carousel';

// Alpine.data('carousel', carousel);
// import Swiper from 'swiper/bundle';
// import {Navigation, Parallax, Mousewheel, FreeMode} from 'swiper/modules';
// document.addEventListener('alpine:init', () => {
//     Alpine.data('reviews', () => ({
//         isStart: true,
//         isEnd: false,
//         carousel(id) {
//
//             const carousel = new Swiper('.js-carousel-' + id, {
//                 modules: [Navigation, Parallax, Mousewheel, FreeMode],
//                 slidesPerView: 'auto',
//                 spaceBetween: 0,
//                 navigation: {
//                     nextEl: '.js-carousel-next-' + id,
//                     prevEl: '.js-carousel-prev-' + id,
//                 },
//             });
//
//             carousel.on('slideChange', () => {
//                 this.isStart = carousel.isBeginning;
//                 this.isEnd = carousel.isEnd;
//             });
//
//         },
//     }));
// });

// const alpineComponents = ['readMore'];
//
// alpineComponents.forEach((name) => {
//     if ([...document.querySelectorAll('[x-data]')].some((el) => el.getAttribute('x-data').startsWith(name))) {
//         import(`./components/${name}`);
//     }
// });

// import './components/readMore'

// if (document.querySelector('[x-data^="readMore"]')) {
//     console.log('hmmm')
//     import './components/readMore';
// }

// const alpineElements = [...document.querySelectorAll('[x-data]')];
//
// if (alpineElements.some((el) => el.getAttribute('x-data').trim().startsWith('readMore'))) {
//     await import('./components/readMore');
// }

window.Alpine = Alpine;
//
// import drawerModal from './components/drawer';
// import megaMenu from './components/mega-menu';
// import readMore from './components/read-more';
//
// document.addEventListener('alpine:init', () => {
//     Alpine.data('drawerModal', drawerModal);
//     Alpine.data('megaMenu', megaMenu);
//     Alpine.data('readMore', readMore);
// });

// // Lazy-load Alpine component if it exists on the page
// const components = import.meta.glob('./components/*.js');
//
// const lazyLoadAlpine = async (selectorPrefix, importPath) => {
//     const alpineElements = [...document.querySelectorAll('[x-data]')];
//
//     if (alpineElements.some(el => el.getAttribute('x-data').trim().startsWith(selectorPrefix))) {
//         const importer = components[importPath];
//
//         if (importer) {
//             await importer();
//         }
//     }
// };
//
// lazyLoadAlpine('readMore', './components/readMore');

Alpine.start();
